export default ['brick', 'wood', 'cinder_block', 'aerated_concrete', 'brick_aerocrete', 'other'];
